module.exports = __webpack_public_path__ + "static/unnamed-5--5e010016816b05421c8b4d5125a45ea9.png";